import { FC } from "react";

import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";

import { CouponLivePreview } from "./CouponLivePreview";
import { ETicketLivePreview } from "./ETicketLivePreview";
import { useCheckInTooltip } from "./helpers/checkInTooltip";

import { CheckInToolsDrawer } from "@/features/CheckInToolsDrawer/CheckInToolsDrawer";

export const ETicketStepLivePreview: FC = () => {
  const {
    isEventForm,
    eTicketPreviewInFocus,
    isTooltipVisible,
    isDrawerOpen,
    isAnimationFrozen,
    dismissTooltip,
    openDrawerFromTooltip,
    closeDrawer,
    logAccordionExpanded,
  } = useCheckInTooltip();

  return (
    <>
      <Fade key={eTicketPreviewInFocus} in appear timeout={250}>
        <Box sx={{ height: "100%", width: "100%" }}>
          {eTicketPreviewInFocus === "coupon" ? (
            <CouponLivePreview />
          ) : (
            <ETicketLivePreview
              checkInPromotion={
                isEventForm
                  ? {
                      isAnimationFrozen,
                      isTooltipVisible,
                      onTooltipDismiss: dismissTooltip,
                      onMoreAboutCheckInClick: openDrawerFromTooltip,
                    }
                  : undefined
              }
            />
          )}
        </Box>
      </Fade>
      {isEventForm && (
        <CheckInToolsDrawer open={isDrawerOpen} onClose={closeDrawer} onAccordionExpand={logAccordionExpanded} />
      )}
    </>
  );
};
